/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

Modal.setAppElement('#root');

export default class ModalDialog extends React.Component {
    static get propTypes() {
        return {
            children: PropTypes.node.isRequired,
            trigger: PropTypes.node.isRequired,
            title: PropTypes.string.isRequired,
            onOpen: PropTypes.func,
            afterOpen: PropTypes.func,
            onClose: PropTypes.func,
            footer: PropTypes.node,
            hideModal: PropTypes.bool
        };
    }

    constructor() {
        super();

        this.state = {
            modalIsOpen: false
        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.hideModal !== nextProps.hideModal) {
            if(nextProps.hideModal) {
                this.closeModal();
            }
        }
    }

    openModal() {
        this.props.setModalOpenStatus(true);
        this.setState({modalIsOpen: true});
        if (this.props.onOpen) {
            this.props.onOpen();
        }
    }

    afterOpenModal() {
        if (this.props.afterOpen) {
            this.props.afterOpen();
        }
    }


    closeModal() {
        this.setState({modalIsOpen: false});
        if (this.props.onClose) {
            this.props.onClose();
        }
        this.props.setModalOpenStatus(false);
    }

    render() {
        const { children } = this.props;

        const childrenWithProps = React.Children.map(children, child =>
            React.cloneElement(child, { onRequestClose: this.closeModal }));

        return (
            <div className="modal-dialog-widget">
                <span onClick={this.openModal}>{this.props.trigger}</span>
                <Modal
                    className="modal-content"
                    overlayClassName="modal-overlay"
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    contentLabel={this.props.title}
                    closeTimeoutMS={150}
                >
                    <div className="modal-header">
                        <div className="modal-close-button" onClick={this.closeModal}>
                            <i className="fa fa-times fa-2x"/>
                        </div>
                        <h4>{this.props.title}</h4>
                    </div>
                    {childrenWithProps}
                </Modal>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widgets/ModalDialog/ModalDialog.js